import { HandshakeOutlineIcon } from './HandshakeOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 11A33144-9847-4ED2-A429-682B79AAE06F
 * name handshake-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/handshake-outline.svg
 * tags
 */
export const DealOutlineIcon = HandshakeOutlineIcon;
export default DealOutlineIcon